export interface Product {
  id: string;
  name: string;
}
export interface ReportingYear {
  endDate: string;
  name: string;
  startDate: string;
  uuid: string;
  isCurrent: boolean;
}

export interface Institution {
  authCode: string;
  authType: string;
  isPssIntegrated: boolean;
  name: string;
  navigatedFrom: string;
  orgLeads: string;
  organization: Organization | null;
  platformUuid: string;
  pssUuid: string;
  reportingYear: ReportingYear;
  rootOrgUuid: string;
  salesforceId: string;
  showCourseEvaluation: boolean;
  showCurriculumTab: boolean;
  showLightcastPreview: boolean;
  showProgramReview: boolean;
  isSllSysAdminIntegrated: boolean;
  rootOrgPlatformUuid: string;
  logoUrl: string | null;
  gainsightEnabled: boolean;
  aiEnabled: boolean;
}

export interface UserInstitution {
  name: string;
  uuid: string;
}

export interface Organization {
  uuid: string;
  name: string;
  type: string;
  code: string;
  platformUuid: string | null;
}
export interface People {
  email: string;
  familyName: string;
  givenName: string;
  middleName: string | null;
  uuid: string;
}
export interface Program {
  code: string;
  name: string;
  uuid: string;
  peopleWithAccess?: People[];
  type: string;
}
export interface OrganizationWithAccess {
  uuid: string;
  name: string;
  type: string;
  code: string;
  peopleWithAccess?: People[];
}
export interface TabOption {
  name: string;
  id: string;
}

export interface LeadInfo {
  leadEmail: string;
  leads: string[];
}

export interface Lead {
  [key: string]: LeadInfo;
}

export interface Membership {
  userRole: string;
  salesforceId: string;
}

export interface Account {
  id: string;
  name: string;
  salesforce_id: string;
}

export interface User {
  email: string;
  firstName: string;
  id: string;
  lastName: string;
  roles: string;
}
export interface GainsightData {
  account: Account;
  apiKey: string;
  user: User;
}

export interface InstitutionInterface {
  name: string;
  uuid: string;
  platformUuid: string;
}
export interface MembershipInterface {
  authCode: number;
  authType: string;
  connectionName: string;
  email: string;
  gainsightData: GainsightData;
  institutions: InstitutionInterface[];
  logoutUrl: string;
  salesforceId: string;
  userModules: any;
  userName: string;
  userRole: string;
}

export interface Plan {
  assessmentTypeId: number;
  status: number;
  title: string;
  updatedAt: string;
  uuid: string;
}

export interface Term {
  academicYear: string;
  startDate: string;
  endDate: string;
  institutionUuid: string;
  name: string;
  termId: string;
  uuid: string;
}

export interface PlanResultSet {
  plans: Plan[];
  selectedPlan: Plan;
}

export interface DrilldownFilters {
  value: string;
  name: string | JSX.Element;
}

export interface InsightsUser {
  email: string;
  firstName: string;
  lastName: string;
  roles: Array<string>;
  uuid: string;
  products: any;
  logoutUrl: string;
  connectionName?: string;
  gainsightData: GainsightData | null;
}

export interface FsDeeplinks {
  activities: string | null;
  "activities:add": string | null;
}

export const defacultFsDeeplinks: FsDeeplinks = {
  activities: null,
  "activities:add": null
};
export const defaultPlan: Plan = {
  assessmentTypeId: 0,
  status: 0,
  title: "",
  updatedAt: "",
  uuid: ""
};

export const defaultPlanResultSet: PlanResultSet = {
  plans: [],
  selectedPlan: defaultPlan
};

export const defaultTerm: Term = {
  academicYear: "",
  startDate: "",
  endDate: "",
  institutionUuid: "",
  name: "",
  termId: "",
  uuid: ""
};
export const defaultReportingYear: ReportingYear = {
  endDate: "",
  name: "",
  startDate: "",
  uuid: "",
  isCurrent: false
};

export const defaultInstitution: Institution = {
  authCode: "",
  authType: "",
  isPssIntegrated: false,
  name: "",
  navigatedFrom: "",
  orgLeads: "",
  organization: null,
  platformUuid: "",
  pssUuid: "",
  reportingYear: defaultReportingYear,
  rootOrgUuid: "",
  salesforceId: "",
  showCourseEvaluation: false,
  showCurriculumTab: false,
  showLightcastPreview: false,
  showProgramReview: false,
  isSllSysAdminIntegrated: false,
  rootOrgPlatformUuid: "",
  logoUrl: null,
  gainsightEnabled: false,
  aiEnabled: false
};

export const defaultOrganization: Organization = {
  uuid: "",
  name: "",
  type: "",
  code: "",
  platformUuid: ""
};

export const defaultMembership: Membership = {
  userRole: "",
  salesforceId: ""
};

export const defaultInsightsUser: InsightsUser = {
  email: "",
  firstName: "",
  uuid: "",
  lastName: "",
  roles: [],
  products: [],
  logoutUrl: "",
  connectionName: "",
  gainsightData: null
};
export interface Instructor {
  email: string;
  firstName: string;
  lastName: string;
  uuid: string;
}
interface studentAssessment {
  awaitingAssessment: number;
  awaitingSubmission: number;
  done: number;
}

export interface StudentAssessmentProgressBySection {
  instructors: Instructor[];
  name: string;
  sectionId: string;
  sectionNumber: string;
  studentAssessments: studentAssessment;
  uuid: string;
}

export interface SettingsReportingYear {
  uuid: string;
  name: string;
  code: string;
  type: string;
  startDate: string;
  endDate: string;
  institutionUuid: string;
  terms: SettingsTerm[];
}

export interface SettingsTerm {
  name: string;
  startDate: string;
  endDate: string;
  uuid: string;
}

export interface notifications {
  id: string;
  message: string;
}
